import React from "react";

import type { CitesStaticHomePageQueryQuery } from "@www/graphql-types";
import { Carousel } from "@www/src/static_pages/components/Carousel";

import { City } from "./City";

type PrismicCities = CitesStaticHomePageQueryQuery["prismicLandingPage"];

export const CityList: React.FC<{
  prismicCities: PrismicCities;
}> = ({ prismicCities }) => {
  return (
    <Carousel slidesPerViewDesktop={4} slidesPerViewTablet={3}>
      {prismicCities?.data.enjoy_service_cities.map((city, index) => (
        <City city={city} key={index} />
      ))}
    </Carousel>
  );
};
